import classNames from 'classnames';
import { UiContextMenuSubProps, UiContextMenuTheme } from '@nx-frontend/shared/types';
import { ContextMenuItem } from './context-menu-item';
import { themeClassesMap } from './context-menu-themes';

export const ContextMenuSub: React.FC<UiContextMenuSubProps> = ({
  menuData,
  closeContextMenu,
  subX,
  subY,
  theme,
  additionStyles,
  classes,
  usePopperSubmenu,
}) => {
  let themeClasses = { menu: '', item: '', subMenu: '' };

  if (classes) {
    themeClasses.subMenu = classes.menu;
    themeClasses.item = classes.item;
  } else {
    themeClasses = themeClassesMap[theme || UiContextMenuTheme.LIGHT];
  }

  const contextMenuClasses = `inline-block rounded-md border py-1 text-sm ${!additionStyles ? 'min-w-[213px]' : ''} ${
    themeClasses.subMenu
  }`;
  return (
    <ul className={classNames('ml-1', contextMenuClasses, additionStyles ?? '')}>
      {menuData.map((item, index) => (
        <ContextMenuItem
          key={index}
          item={item}
          closeContextMenu={closeContextMenu}
          subX={subX}
          subY={subY}
          theme={theme}
          classes={classes}
          usePopperSubmenu={usePopperSubmenu}
        />
      ))}
    </ul>
  );
};
